import * as React from 'react';
import SkillsDimension, { getInitialSkills, Props } from './skills_dimension';
import { shallow, ShallowWrapper } from 'enzyme';
import curatorsApplicationDummy from '__fixtures__/curators_application_dummy';
import curatorsTalentUserDummy from '__fixtures__/curators_talent_user_dummy';

describe('Skills Dimension component', () => {
  let wrapped: ShallowWrapper;

  beforeEach(() => {
    const application = curatorsApplicationDummy.data.attributes;
    const talentUser = curatorsTalentUserDummy.data.attributes;

    wrapped = shallow(
      <SkillsDimension
        application={curatorsApplicationDummy.data.attributes}
        rating={3}
        skills={getInitialSkills({ application, talentUser })}
        setNotes={jest.fn()}
        setRating={jest.fn()}
        setSkills={jest.fn()}
        user={talentUser}
      />
    );
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

describe('getInitialSkills', () => {
  type InitialSkill = { type: string; name: string; tagId: number; years?: number };

  const application = {
    job_ad: {
      must_have_skills: [
        { id: 1, name: 'React' },
        { id: 2, name: 'TypeScript' },
        { id: 3, name: 'Rust' },
      ],
      other_required_skills: [],
      nice_to_have_skills: [],
    },
  };

  const talentUser = {
    skills: [
      { tag_id: 1, name: 'React', experience: null },
      { tag_id: 2, name: 'TypeScript', experience: 5 },
    ],
  };

  const initialSkills = () =>
    getInitialSkills({ application, talentUser }).toArray() as InitialSkill[];

  it('uses -1 for skills present on the profile without years (e.g. CV-inferred)', () => {
    const react = initialSkills().find(s => s.tagId === 1);
    expect(react!.years).toBe(-1);
  });

  it('keeps the recorded years when the candidate has them', () => {
    const ts = initialSkills().find(s => s.tagId === 2);
    expect(ts!.years).toBe(5);
  });

  it('leaves years undefined when the candidate does not have the skill', () => {
    const rust = initialSkills().find(s => s.tagId === 3);
    expect(rust!.years).toBeUndefined();
  });
});
